import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { deletePost, deletePostFromStore, getPostDetails, setActivePost, getPostReadList, clearPostReadList } from 'actions/posts';
import { getReaderParameters } from 'actions/user';
import Date from 'components/Presentation/Date/Date';
import PostContent from 'components/Presentation/PostContent';
import PostForm from 'containers/Forms/Post';
import Modal from 'containers/Modals/Modal';
import { trackImmersiveReaderError } from 'helpers/insights';
import { getRootUrl } from 'helpers/url';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import swal from 'sweetalert2';
import { Spinner } from 'UI';
import Block, { BlockWrapper } from 'UI/Elements/Block';
import { Immersive_Reader } from 'UI/Icons';
import { Block as ContentBlock, Button, Icon, Flex } from '@haldor/ui';
import Post from '_class/Post';
import User from '_class/User';
import { setPageTitle, setPageActions } from 'actions/header';
import FileItem from 'components/FileItem';
import ProgressBar from 'UI/Elements/ProgressBar';
import Moment from 'moment';
import FromNow from 'components/Presentation/Date/FromNow';

var ImmersiveReader = require('@microsoft/immersive-reader-sdk');

var SinglePost = /*#__PURE__*/function (_Component) {
  _inherits(SinglePost, _Component);

  var _super = _createSuper(SinglePost);

  function SinglePost(props) {
    var _this;

    _classCallCheck(this, SinglePost);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.setActivePost();

      _this.props.clearPostReadList();

      ImmersiveReader.close();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, posts, currentUser, match;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, posts = _this$props.posts, currentUser = _this$props.currentUser, match = _this$props.match;

              if (!(posts.length > 0)) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return _this.props.setActivePost(match.params.id);

            case 4:
              _context.next = 6;
              return _this.props.getPostDetails(match.params.id)["catch"](function (error) {
                if (error.status == 204) {
                  _this.setState({
                    showPostNotFound: true
                  });
                }
              });

            case 6:
              if (_this.props.activePost != null) {
                if (_this.props.activePost.creator == currentUser.id || _this.props.activePost.editable) {
                  _this.props.getPostReadList(match.params.id).then(function () {
                    _this.setState({
                      loadingReadlist: false
                    });
                  });
                } else {
                  _this.props.clearPostReadList();
                }

                _this.props.setPageTitle(_this.props.activePost.title);
              } else {
                _this.props.clearPostReadList();
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "editButton", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: 5
        },
        onClick: _this.openModal
      }, _this.props.translate('Edit')));
    });

    _defineProperty(_assertThisInitialized(_this), "deleteButton", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: 5
        },
        onClick: _this.openDeleteModal
      }, _this.props.translate('Delete')));
    });

    _defineProperty(_assertThisInitialized(_this), "openDeleteModal", function () {
      var translate = _this.props.translate;
      swal.fire({
        title: translate('Delete'),
        text: translate('delete-post-prompt'),
        showCancelButton: true,
        cancelButtonText: translate('Cancel'),
        confirmButtonText: translate('Delete')
      }).then(function (result) {
        if (result.value != null) {
          _this.props.deletePost(_this.props.match.params.id).then(function () {
            _this.props.deletePostFromStore(_this.props.match.params.id);

            _this.props.history.push(getRootUrl());
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDeleteModal", function () {
      _this.setState({
        deleteModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (proxy, skipPrompt) {
      _this.props.getPostDetails(_this.props.match.params.id).then(function () {
        _this.setState({
          modalIsOpen: false
        });

        _this.props.setPageTitle(_this.props.activePost.title);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "runImmersiveReader", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var post, currentUser, localLanguage, data, reader;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              post = new Post(_this.props.activePost);
              currentUser = _this.props.currentUser;
              localLanguage = localStorage.getItem('language');
              data = {
                title: post.getName(),
                chunks: [{
                  content: '<h1>' + post.getName() + '</h1>',
                  mimeType: 'text/html'
                }, {
                  content: post.getDescription(),
                  mimeType: 'text/html'
                }]
              };
              _context2.next = 6;
              return _this.props.getReaderParameters();

            case 6:
              reader = _this.props.reader;
              ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                uiLang: localLanguage // Set immersive reader UI language to selected lang in Haldor Edu

              })["catch"](function (error) {
                console.error('error', error);
                trackImmersiveReaderError(error, currentUser.id);
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "toggleRelationshipList", function () {
      if (_this.props.readList.length > 200) {
        var _translate = _this.props.translate;
        swal.fire({
          title: '',
          text: _translate('Since the post was shared with more than 200 people, you can not see who read it'),
          showCancelButton: false,
          confirmButtonText: _translate('Ok')
        });
        return true;
      }

      _this.setState({
        relationshipList: !_this.state.relationshipList
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderReadList", function () {
      var _this$props2 = _this.props,
          translate = _this$props2.translate,
          readList = _this$props2.readList;
      var relationshipList = _this.state.relationshipList;

      if (readList != null && readList.length > 200) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        isOpen: relationshipList,
        overridePrompt: true,
        onClose: _this.toggleRelationshipList,
        title: translate('shared-with')
      }, /*#__PURE__*/React.createElement("div", {
        className: "form single-post-read-list"
      }, readList != null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "table"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('read-post'))), readList.map(function (read) {
        return read.hasRead ? /*#__PURE__*/React.createElement("div", {
          className: "user-item",
          key: read.userId
        }, read.user.firstName, " ", read.user.lastName, " ", /*#__PURE__*/React.createElement(Icon, {
          name: "Eye"
        })) : null;
      }), /*#__PURE__*/React.createElement("div", null, "\xA0")), /*#__PURE__*/React.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('not-read-post'))), readList.map(function (read) {
        return read.hasRead ? null : /*#__PURE__*/React.createElement("div", {
          className: "user-item",
          key: read.userId
        }, read.user.firstName, " ", read.user.lastName);
      }))))) : /*#__PURE__*/React.createElement("div", {
        className: "color--meta text--center size-12"
      }, "Ingen har l\xE4st inl\xE4gget")));
    });

    _this.state = {
      loadingReadlist: true,
      modalIsOpen: false,
      relationshipList: false,
      showPostNotFound: false
    };
    return _this;
  }

  _createClass(SinglePost, [{
    key: "render",
    value: function render() {
      var activePost = this.props.activePost;

      if (this.state.showPostNotFound) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '1rem 0'
          },
          className: "text--center color--meta weight--bold"
        }, this.props.translate('You do not have permission to view the post')))));
      }

      if (typeof activePost == 'undefined' || activePost == null || Object.keys(activePost).length == 0) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      var readCount = 0;
      var percentage = 0;

      if (this.props.readList != null) {
        readCount = _toConsumableArray(this.props.readList).filter(function (read) {
          return read.hasRead;
        }).length;
        percentage = Math.round(100 / this.props.readList.length * readCount);
      }

      var user = new User(this.props.currentUser);
      var post = new Post(this.props.activePost);
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, this.renderReadList(), activePost.creator == this.props.currentUser.id || activePost.editable ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modalIsOpen,
        onClose: this.closeModal,
        title: this.props.translate('edit-post')
      }, /*#__PURE__*/React.createElement(PostForm, {
        selectMultipleSchools: activePost.relationships.find(function (ss) {
          return ss.referenceType == 'SCHOOL';
        }) != null,
        onModalClose: this.closeModal
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: '0'
        }
      }, /*#__PURE__*/React.createElement(ContentBlock, null, activePost.status == 'POST_DRAFT' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.35rem'
        }
      }, this.props.translate('Draft')) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-task-description"
      }, activePost.published != null && Moment.utc(activePost.published).isAfter(Moment()) ? /*#__PURE__*/React.createElement("div", {
        className: "pull-right"
      }, /*#__PURE__*/React.createElement(FromNow, {
        style: {
          marginTop: 0
        }
      }, Moment.utc(activePost.published).local().format())) : null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('description')), this.props.services.immersiveReaderPosts ? /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.runImmersiveReader
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), this.props.translate('immersive-reader')))) : null, /*#__PURE__*/React.createElement(PostContent, null, post.getDescription())), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('date')), activePost.status == 'POST_PUBLISHED' ? /*#__PURE__*/React.createElement(Date, null, activePost.published) : this.props.translate('Not-published')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('column-created-by')), activePost.author != null ? activePost.author : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('shared-with'), this.props.activePost.targetAudience != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: '.35rem',
          position: 'relative',
          top: '-2px'
        },
        className: "color--meta size-12"
      }, "(", this.props.translate(this.props.activePost.targetAudience.toLowerCase()), ")") : null), this.props.activePost.relationships.map(function (relationship) {
        return /*#__PURE__*/React.createElement("div", {
          key: relationship.referenceId
        }, relationship.referenceTitle);
      }))), activePost.associatedFiles != null && activePost.associatedFiles.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "preschool-gallery",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: "2"
      }, activePost.associatedFiles.map(function (file, index) {
        if (file.type != null && file.type.indexOf('image') > -1) {
          return /*#__PURE__*/React.createElement(Block, {
            key: "file-".concat(file.id, "-").concat(index)
          }, /*#__PURE__*/React.createElement(FileItem, {
            file: file,
            style: {
              width: '100%',
              height: '100%',
              display: 'block',
              borderRadius: 'inherit'
            }
          }));
        }

        if (file.type != null) {
          return /*#__PURE__*/React.createElement(Block, {
            key: "file-".concat(file.id, "-").concat(index)
          }, /*#__PURE__*/React.createElement(FileItem, {
            file: file
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              padding: '0.755rem'
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'inline-block',
              position: 'relative',
              top: 3,
              marginRight: '0.25rem'
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "File"
          })), file.name)));
        }

        return null;
      }))) : null), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('tools')), activePost.creator == this.props.currentUser.id || activePost.editable ? this.editButton() : null, activePost.deletable ? this.deleteButton() : null, this.props.readList != null && this.props.readList.length > 0 && !this.state.loadingReadlist ? /*#__PURE__*/React.createElement("div", {
        className: "single-post-read-list-trigger",
        onClick: this.toggleRelationshipList
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Eye"
      }), percentage, "% (", readCount, "/", this.props.readList.length, ") ", this.props.translate('have-read')) : null, this.props.readList != null && this.props.readList.length > 0 && !this.state.loadingReadlist ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: 230
        }
      }, /*#__PURE__*/React.createElement(ProgressBar, {
        percentage: percentage,
        fillColor: "var(--color--meta)"
      })) : null)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }]);

  return SinglePost;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    posts: state.Posts.posts,
    activePost: state.Posts.activePost,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    reader: state.user.reader,
    readList: state.Posts.readList
  };
}

export default withRouter(connect(mapStateToProps, {
  setActivePost: setActivePost,
  getPostDetails: getPostDetails,
  deletePost: deletePost,
  deletePostFromStore: deletePostFromStore,
  getReaderParameters: getReaderParameters,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getPostReadList: getPostReadList,
  clearPostReadList: clearPostReadList
})(SinglePost));